import { Leaf, Sprout, Beaker, Bug, Droplets, Waves, Shovel, Wheat } from "lucide-react";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SEVERITY_COLORS = {
  faible: { bg: "#E9C46A20", text: "#92700E", label: "Faible" },
  moyen: { bg: "#E07A5F20", text: "#C25A3F", label: "Moyen" },
  severe: { bg: "#EF444420", text: "#DC2626", label: "Severe" },
};
export const STATUS_COLORS = {
  actif: { bg: "#EF444415", text: "#DC2626", label: "Actif" },
  en_surveillance: { bg: "#E9C46A20", text: "#92700E", label: "En surveillance" },
  resolu: { bg: "#2D6A4F15", text: "#2D6A4F", label: "Resolu" },
};
export const TYPE_ICONS = {
  phyto: { icon: Leaf, color: "#2D6A4F", bg: "#2D6A4F12" },
  fertilisation: { icon: Sprout, color: "#8B5E3C", bg: "#8B5E3C12" },
  analyse_sol: { icon: Beaker, color: "#6366F1", bg: "#6366F115" },
  sanitaire: { icon: Bug, color: "#E07A5F", bg: "#E07A5F12" },
  biostimulant: { icon: Droplets, color: "#0891B2", bg: "#0891B212" },
  irrigation: { icon: Waves, color: "#2B7BB9", bg: "#2B7BB914" },
  plantation: { icon: Shovel, color: "#3F7D3A", bg: "#3F7D3A14" },
  recolte: { icon: Wheat, color: "#9A6A12", bg: "#9A6A1214" },
};
